import axiosClient from "utils/axios";
import { ApiList, ApiResponse } from "types/api.types";
import { Settlement } from "features/ClientAdvanceSettlements/types/client-advance-settlement.types";
import type { ClientAdvanceSettlementSourceType } from "features/ClientAdvanceSettlements/constants/client-advance-settlement.constants";

export const getClientAdvanceSettlements = async ({
  page,
  limit,
  search,
  clientAdvanceId,
  sourceType,
  sourceId,
}: {
  page?: number;
  limit?: number;
  search?: string;
  clientAdvanceId?: number;
  /** INVOICE or MANUAL — invalid values are silently ignored by the API. */
  sourceType?: ClientAdvanceSettlementSourceType | string;
  sourceId?: number;
} = {}) => {
  try {
    const response = await axiosClient.get<ApiResponse<ApiList<Settlement[]>>>(
      "/client-advance-settlements",
      { params: { page, limit, search, clientAdvanceId, sourceType, sourceId } },
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Client Advance Settlement list : ", err);
    throw err;
  }
};

export const getClientAdvanceSettlement = async (id: number) => {
  try {
    if (!Number.isInteger(id) || id <= 0) {
      throw new Error("Invalid ID");
    }
    const response = await axiosClient.get<ApiResponse<Settlement>>(
      `/client-advance-settlements/${id}`,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching Client Advance Settlement details : ", err);
    throw err;
  }
};
